import { getType } from '@/nebula/type';
import { isReferenced } from '@/nebula/references';
import { ref } from 'vue';

export const addToDenormalize = (uid, model, toDenormalize) => {
  if (toDenormalize[model] === undefined) {
    toDenormalize[model] = { [uid]: true };
    return;
  }
  toDenormalize[model][uid] = true;
};

export const dn = ref({});
const findReverseReference = (uid, referencedBy, references, res, schema) => {
  if (references[uid] === undefined) {
    return;
  }

  Object.values(references[uid]).forEach((r) => {
    if (r.uid === referencedBy) {
      return;
    }
    const rEdge = r.edges.find((e) => e.edge.includes('~'));
    if (rEdge === undefined) {
      return;
    }

    const edge = rEdge.edge.substring(1);
    const edgeType = getType(schema[rEdge.type].schema[edge]);
    if (Object.keys(schema[rEdge.type].excludeFromDenormalization).includes(edge)) {
      return;
    }

    if (!isReferenced(edgeType, schema) && schema[edgeType].reverseEdges === undefined) {
      return;
    }

    if (res[rEdge.type] === undefined) {
      findReverseReference(r.uid, uid, references, res, schema);
      res[rEdge.type] = { [r.uid]: true };
      return;
    }
    if (res[rEdge.type][r.uid] === true) {
      return;
    }
    findReverseReference(r.uid, uid, references, res, schema);
    res[rEdge.type][r.uid] = true;
  });
};

export const findReverseReferences = (res, references, schema) => {
  const uids = Object.keys(res).reduce((r, model) => {
    r.push(...Object.keys(res[model]));
    return r;
  }, []);
  uids.forEach((uid) => {
    findReverseReference(uid, null, references, res, schema);
  });
  return res;
};
